<template>
  <form 
    :class="[
      {'sm-input-wrap': !isInputTextStyles}, 
      {'sm-input-wrap-2': isInputTextStyles}, 
      inputFocusClass
    ]"
    @submit.prevent="$emit('submit')"
  >
    <span 
      @click="setInputFocus"
    >
      <svg class="sm-icons sm-icon-search">
        <use xlink:href="#icon-search"/>
      </svg>
    </span>
    <input type="text" 
      :placeholder="placeholder"
      :class="[
        {'sm-input-search': !isInputTextStyles}, 
        {'sm-input-search-2': isInputTextStyles}
      ]"
      v-model="value"
      ref="input-search"
      @focus="handleFocus"
      @blur="handleBlur"
      @input="$emit('input', value)"
    >
    <button
      class=""
      type="button"
      v-if="value"
      @click="closeButton"
    ></button>
  </form>
</template>

<script>
export default {
  name: 'input-search',
  data() {
    return {
      inputFocusClass: '',
      value: ''
    }
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search...'
    },
    defaultVal: {
      type: String,
      default: ''
    },
    isInputTextStyles: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.value = this.defaultVal;
  },
  methods: {
    setInputFocus() {
      this.$refs['input-search'].focus();
    },
    handleFocus() {
      this.inputFocusClass = 'focus';
    },
    handleBlur() {
      if (!this.value) 
        this.inputFocusClass = '';
    },
    closeButton() {
      this.value = '';
      this.inputFocusClass = '';
      this.$emit('input', '');
    }
  },
  watch: {
    defaultVal(val) {
      this.value = val;
    }
  }
}
</script>